// import styled from 'styled-components';

// type CardProps = { $alpha?: number };  // transient prop (won’t hit the DOM)

// const Card = styled.div<CardProps>`
//   /* Match FloatingSidebar / AuthModal "card" styling */
//   --card-alpha: ${({ $alpha = 0.96 }) => $alpha};
//   position: relative;
//   overflow: hidden;
//   border-radius: 16px;                               /* same as sidebar/modal */
//    background: linear-gradient(
//     180deg,
//     rgba(20,22,28, var(--card-alpha)),
//     rgba(18,20,25, var(--card-alpha))
//   );
//   color: #E8EAED;                                     /* pale text like modal */
//   border: 1px solid rgba(255,255,255,.06);            /* soft, subtle border */
//   box-shadow: 0 18px 48px rgba(0,0,0,.45);            /* same depth as modal */
//   padding: ${({ theme }) => theme.spacing(4)};
// `;

// export default Card;







import styled from 'styled-components';

/* EXACT match to FloatingSidebar surface */
const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(20,22,28,.96), rgba(18,20,25,.96));
  color: #E8EAED;
  border: 1px solid rgba(255,255,255,.06);
  box-shadow: 0 18px 48px rgba(0,0,0,.45);
  padding: ${({ theme }) => theme.spacing(4)};
`;


export default Card;